import { createSlice } from "@reduxjs/toolkit";

const productSlice = createSlice({
    name:"products",
    initialState:{
        products:null
    },
    reducers:{
        setProductList(state,action){
            state.products = action?.payload;
        },
    }
})


export const {setProductList} = productSlice.actions
export default productSlice.reducer